export default {
  namespaced: true,
  state: {
    list: [],
    add: [],
    selected: {},
    editUser: false,
    editUserObj: {},
  },
  getters: {
    list: state => state.list,
    add: state => state.add,
    selected: state => state.selected,
    editUser: state => state.editUser,
    editUserObj: state => state.editUserObj,
  },
  mutations: {
    listMutate(state, data) {
      state.list = data;
    },
    addMutate(state, data) {
      state.add = data;
    },
    selectMutate(state, data) {
      state.selected = data;
    },
    editUserMutate(state, data) {
      state.editUser = data;
    },
    editUserObjMutate(state, data) {
      state.editUserObj = data;
    },
  },
  actions: {
    setList(context, data) {
      context.commit('listMutate', data);
    },
    setAdd(context, data) {
      context.commit('addMutate', data);
    },
    selectAction(context, data) {
      context.commit('selectMutate', data);
    },
    setEditUser(context, data) {
      context.commit('editUserMutate', data);
    },
    setEditUserObj(context, data) {
      context.commit('editUserObjMutate', data);
    },
  },
};
